import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
const EMERGENCY_AUTO_GLASS_FAQS = [{
  question: 'Do you offer emergency auto glass near me?',
  answer: "Kosin's Glass serves Howell, Ann Arbor, Novi and surrounding Southeast Michigan communities. Call or request an urgent quote and the team will confirm today's availability for your vehicle and glass type."
}, {
  question: 'Can I get same-day windshield replacement?',
  answer: 'Same-day openings may be available depending on your vehicle, glass availability, insurance details and the schedule. Call 517-545-7772 to check the fastest available option.'
}, {
  question: 'My windshield is cracked. Is it safe to drive?',
  answer: "If the crack blocks your view, is spreading, is near the windshield edge, or makes the vehicle feel unsafe, do not continue driving. Call Kosin's Glass for guidance on the safest next step."
}, {
  question: 'Can a broken windshield be repaired today?',
  answer: "Small chips may be repairable if they are contained, away from the driver's line of sight and away from the windshield edge. Cracks are generally not repairable and usually require replacement."
}, {
  question: 'Do you replace shattered side windows and rear windows?',
  answer: "Yes. Kosin's Glass replaces side windows, driver and passenger door glass, power window glass, quarter glass and rear vehicle glass."
}, {
  question: "Can Kosin's Glass help with insurance?",
  answer: "Yes. Kosin's Glass works with most insurance companies and can help with quote details, claim coordination and scheduling."
}, {
  question: 'Will I need ADAS calibration after emergency windshield replacement?',
  answer: "If your vehicle has a forward-facing camera or driver-assistance sensors near the windshield, calibration may be required after replacement. Kosin's Glass offers on-site ADAS calibration."
}, {
  question: 'What information should I have ready when I call?',
  answer: 'Have your vehicle year, make, model, which glass is damaged, a photo if possible, insurance information and your best callback number ready.'
}, {
  question: 'Do you repair truck, van, fleet or semi-truck glass?',
  answer: "Yes. Kosin's Glass handles auto glass for cars, trucks, vans, fleet vehicles and semi trucks. Availability depends on the vehicle and glass needed."
}, {
  question: 'Are you open on weekends?',
  answer: "Kosin's Glass is open Monday through Friday from 8:00 a.m. to 5:00 p.m. and Saturday from 9:00 a.m. to 3:00 p.m. Sunday is closed."
}];
export function EmergencyAutoGlassFAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-45">
      <div className="max-w-3xl mx-auto" data-id="element-46">
        <div className="text-center mb-12" data-id="element-47">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-tight leading-tight" data-id="element-48">
            <span className="text-emergencyBrand-red" data-id="element-49">
              Emergency Auto Glass
            </span>{' '}
            Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-50">
          {EMERGENCY_AUTO_GLASS_FAQS.map((item, idx) => {
          const isOpen = openIdx === idx;
          const panelId = `emergency-faq-panel-${idx}`;
          const buttonId = `emergency-faq-button-${idx}`;
          return <div key={idx} className={`border rounded-xl transition-colors ${isOpen ? 'border-emergencyBrand-redBorder bg-emergencyBrand-redLight/40' : 'border-slate-200 bg-white'}`} data-id="element-51">
                <button type="button" id={buttonId} aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIdx(isOpen ? null : idx)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-emergencyBrand-red rounded-xl" data-id="element-52">
                  <span className="text-lg font-bold text-slate-900 pr-8" dangerouslySetInnerHTML={{
                __html: item.question
              }} data-id="element-53" />
                  <ChevronDown className={`w-6 h-6 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-emergencyBrand-red' : 'text-slate-400'}`} aria-hidden="true" data-id="element-54" />
                </button>
                <div id={panelId} role="region" aria-labelledby={buttonId} className={`grid transition-[grid-template-rows] duration-300 ease-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-55">
                  <div className="overflow-hidden" data-id="element-56">
                    <div className="px-6 pb-6 text-slate-600 text-lg leading-relaxed" dangerouslySetInnerHTML={{
                  __html: item.answer
                }} data-id="element-57" />
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}